import { useLanguageContext } from "../../../../context/LanguageContext";
import DishPage from "../../../../pages/canteen/dishes/dish/DishPage";
import { useDishEditRouteValidator } from "../../../validators/canteen/dishes/DishEditRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useDishesRouteConfig from "./DishesRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useDishEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/canteen/dishes/:dish/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.dish"),
        },
      ])
    )
    .setValidator(useDishEditRouteValidator())
    .setPage(<DishPage />)
    .setParent(useDishesRouteConfig());
}

export default useDishEditRouteConfig;
